import { LoadableRoute } from 'routes/utils/loadable';

export const SetPasswordContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "SetPassword" */ './SetPassword'),
});
